/* Reviews hub (/pages/reviews): the score (when the page does not serve it), the highlights' dots on phones, and
   the list of reviews with its filters and "Show more". Reviews and the score are Okendo's own, from its storefront
   API in the visitor's language; drawn with textContent only, never edited. */
(function () {
  if (window.__reviewsHub) return;
  window.__reviewsHub = true;
  var API = 'https://api.okendo.io/v1/stores/';
  var DEFAULT_TITLE = /^\s*\d\s+\S+\s*$/; /* Okendo's placeholder title: "5 Stars", "5 Stjärnor" */

  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function fill(tpl, map) { return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
  function num(v, lang) { try { return Number(v).toLocaleString(lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 }); } catch (e) { return Number(v).toFixed(1); } }
  function json(url) { return fetch(url).then(function (r) { if (!r.ok) throw r.status; return r.json(); }); }
  function country(code, lang) { if (!code) return ''; try { return new Intl.DisplayNames([lang], { type: 'region' }).of(code); } catch (e) { return ''; } }
  function date(iso, lang) { try { return new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(iso)); } catch (e) { return ''; } }
  function stars(rating, tpl, lang) {
    var s = el('span', 'rvx__stars'), f = el('span');
    s.setAttribute('role', 'img'); s.setAttribute('aria-label', fill(tpl, { rating: num(rating, lang) }));
    f.style.width = Math.max(0, Math.min(100, rating / 5 * 100)) + '%'; s.appendChild(f); return s;
  }

  /* "✓ Verified buyer" at the end of the product line (Marcus 2026-11-03, option D), only when Okendo marks the reviewer */
  function verifiedMark(cls, label) {
    var s = el('span', cls), NS = 'http://www.w3.org/2000/svg', svg = document.createElementNS(NS, 'svg'), p = document.createElementNS(NS, 'path');
    svg.setAttribute('width', '11'); svg.setAttribute('height', '11'); svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '2.6'); svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round'); svg.setAttribute('aria-hidden', 'true');
    p.setAttribute('d', 'M5.5 12.5l4.2 4 8.8-9.5'); svg.appendChild(p); s.appendChild(svg); s.appendChild(document.createTextNode(label)); return s;
  }

  /* 1 · The score */
  function score(box) {
    if (box.dataset.ready || box.hasAttribute('data-served')) return;
    box.dataset.ready = '1';
    var lang = box.getAttribute('data-locale') || 'en';
    json(API + encodeURIComponent(box.getAttribute('data-store')) + '/collections/' + encodeURIComponent(box.getAttribute('data-group')) + '/review_aggregate?locale=' + lang)
      .then(function (d) {
        var a = d && d.reviewAggregate; if (!a || !a.reviewCount) return;
        var n = a.reviewCount, avg = a.reviewRatingValuesTotal / n, rec = a.recommendationCount || 0, lv = a.reviewCountByLevel || {};
        box.querySelector('[data-rvx-avg]').textContent = num(avg, lang);
        var s = box.querySelector('[data-rvx-stars]');
        s.setAttribute('aria-label', fill(box.getAttribute('data-stars'), { rating: num(avg, lang) }));
        s.firstElementChild.style.width = Math.min(100, avg / 5 * 100) + '%';
        box.querySelector('[data-rvx-count]').textContent = fill(box.getAttribute(rec === n ? 'data-rec-all' : 'data-rec'), { count: n.toLocaleString(lang), rec: rec.toLocaleString(lang) });
        box.querySelectorAll('[data-level]').forEach(function (li) {
          var k = li.getAttribute('data-level'), c = lv['level' + k + 'Count'] || 0;
          li.querySelector('.rvx-score__track > span').style.width = (c / n * 100) + '%';
          li.querySelector('.rvx-score__n').textContent = c.toLocaleString(lang);
          li.setAttribute('aria-label', fill(box.getAttribute('data-stars'), { rating: k }) + ': ' + c);
        });
        box.removeAttribute('data-pending');
      }).catch(function () {});
  }

  /* 2 · Highlights. "Latest": the two newest reviews replace the served ones once Okendo answers. Dots on phones. */
  var QUOTE_MAX = 60; /* characters: two lines of the quote in a desktop column */
  function quote(r) {
    var title = (r.title || '').trim(), body = (r.body || '').trim();
    if (title && !DEFAULT_TITLE.test(title)) return title;
    var m = body.match(/^[\s\S]*?[.!?](?=\s|$)/); return (m ? m[0] : body).trim();
  }
  function hlItem(r, sec, lang) {
    var title = (r.title || '').trim(), body = (r.body || '').trim();
    if (!title || DEFAULT_TITLE.test(title)) { var m = body.match(/^[\s\S]*?[.!?](?=\s|$)/); title = m ? m[0] : body; body = body.slice(title.length).trim(); }
    var a = el('article', 'rvx-hl__item'), root = sec.getAttribute('data-root') || '';
    var st = stars(r.rating, sec.getAttribute('data-stars'), lang); st.classList.add('rvx__stars--14'); a.appendChild(st);
    a.appendChild(el('p', 'rvx__q', '\u201C' + title + '\u201D'));
    a.appendChild(el('p', 'rvx-hl__cap', body || null)); /* always there: each part keeps its row on desktop */
    var rule = el('span', 'rvx__rule'); rule.setAttribute('aria-hidden', 'true'); a.appendChild(rule);
    var who = el('div', 'rvx__who'), href = r.productHandle ? root + '/products/' + r.productHandle : '';
    if (r.productImageUrl && href) { var pic = el('a', 'rvx__pic'); pic.href = href; pic.tabIndex = -1; pic.setAttribute('aria-hidden', 'true'); var img = el('img'); img.src = r.productImageUrl; img.alt = ''; img.width = 48; img.height = 60; img.loading = 'lazy'; pic.appendChild(img); who.appendChild(pic); }
    var w = el('div'), rv = r.reviewer || {}, c = country(rv.location && rv.location.country && rv.location.country.code, lang);
    w.appendChild(el('p', 'rvx__name', [rv.displayName || '', c].filter(Boolean).join(' \u00B7 ')));
    var meta = el('p', 'rvx__meta'), name = (r.productName || '').split(' \u2013 ')[0];
    if (name && href) { var l = el('a', null, name); l.href = href; meta.appendChild(l); } else if (name) meta.appendChild(document.createTextNode(name));
    var d = ''; try { d = new Intl.DateTimeFormat(lang, { month: 'short', year: 'numeric' }).format(new Date(r.dateCreated)); } catch (e) {}
    if (d) meta.appendChild(document.createTextNode((name ? ' \u00B7 ' : '') + d));
    if (rv.isVerified) { meta.appendChild(document.createTextNode(' \u00B7 ')); meta.appendChild(verifiedMark('rvx__ok', sec.getAttribute('data-verified'))); }
    w.appendChild(meta); who.appendChild(w); a.appendChild(who);
    return a;
  }
  function highlights(sec) {
    if (sec.dataset.ready) return; sec.dataset.ready = '1';
    if (sec.hasAttribute('data-latest')) {
      var lang = sec.getAttribute('data-locale') || 'en', tr = sec.querySelector('[data-rvx-hl-track]');
      json(API + encodeURIComponent(sec.getAttribute('data-store')) + '/collections/' + encodeURIComponent(sec.getAttribute('data-group')) + '/reviews?limit=8&orderBy=date+desc&locale=' + lang)
        .then(function (d) {
          /* The two newest whose quote fits in two lines, as the pillar's band: the parts share rows, so one long quote
             would leave empty lines under the other. Nothing is cut; the longer ones are in the list below. */
          var rs = (d.reviews || []).filter(function (r) { return r && (r.body || r.title) && quote(r).length <= QUOTE_MAX; }).slice(0, 2);
          if (rs.length < 2) return;
          tr.textContent = ''; rs.forEach(function (r) { tr.appendChild(hlItem(r, sec, lang)); });
          sec.querySelector('[data-rvx-hl-dots]').textContent = '';
          dotsFor(sec);
        }).catch(function () {});
    }
    dotsFor(sec);
  }
  function dotsFor(sec) {
    var track = sec.querySelector('[data-rvx-hl-track]'), dots = sec.querySelector('[data-rvx-hl-dots]');
    var items = [].slice.call(track.children); if (items.length < 2 || !dots) return;
    items.forEach(function (it, i) { var b = el('button'); b.type = 'button'; b.tabIndex = -1; b.addEventListener('click', function () { track.scrollTo({ left: it.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }); dots.appendChild(b); });
    function mark() { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); [].forEach.call(dots.children, function (d, k) { d.setAttribute('aria-current', String(k === i)); }); }
    track.addEventListener('scroll', mark, { passive: true }); mark();
  }

  /* 3 · All reviews */
  function list(sec) {
    if (sec.dataset.ready) return; sec.dataset.ready = '1';
    var grid = sec.querySelector('[data-rvx-grid]'), more = sec.querySelector('[data-rvx-more]');
    var filters = [].slice.call(sec.querySelectorAll('[data-rvx-filter]'));
    var lang = sec.getAttribute('data-locale') || 'en', root = sec.getAttribute('data-root') || '', n = +sec.getAttribute('data-count') || 9;
    var base = API + encodeURIComponent(sec.getAttribute('data-store')), next = null, busy = false, seq = 0;
    function card(r) {
      var title = (r.title || '').trim(), body = (r.body || '').trim();
      if (!title || DEFAULT_TITLE.test(title)) { var m = body.match(/^[\s\S]*?[.!?](?=\s|$)/); title = m ? m[0] : body; body = body.slice(title.length).trim(); }
      var a = el('article', 'rvx-card');
      a.appendChild(stars(r.rating, sec.getAttribute('data-stars'), lang));
      a.appendChild(el('p', 'rvx__q', '“' + title + '”'));
      if (body) a.appendChild(el('p', 'rvx-card__b', body));
      if (body) {
        /* An arrow under a text cut at four lines opens the whole review, and closes it again (Marcus 2026-11-03) */
        var tg = el('button', 'rvx-card__tg'), NS = 'http://www.w3.org/2000/svg', sv = document.createElementNS(NS, 'svg'), pa = document.createElementNS(NS, 'path');
        tg.type = 'button'; tg.hidden = true; tg.setAttribute('aria-expanded', 'false'); tg.setAttribute('aria-label', sec.getAttribute('data-open'));
        sv.setAttribute('width', '14'); sv.setAttribute('height', '14'); sv.setAttribute('viewBox', '0 0 24 24'); sv.setAttribute('fill', 'none'); sv.setAttribute('stroke', 'currentColor');
        sv.setAttribute('stroke-width', '1.6'); sv.setAttribute('stroke-linecap', 'round'); sv.setAttribute('stroke-linejoin', 'round'); sv.setAttribute('aria-hidden', 'true');
        pa.setAttribute('d', 'M5 9l7 7 7-7'); sv.appendChild(pa); tg.appendChild(sv);
        tg.addEventListener('click', function () {
          var open = tg.getAttribute('aria-expanded') !== 'true';
          tg.setAttribute('aria-expanded', String(open)); tg.setAttribute('aria-label', sec.getAttribute(open ? 'data-close' : 'data-open'));
          a.classList.toggle('is-open', open); fade();
        });
        a.appendChild(tg);
      }
      var who = el('div', 'rvx__who'), href = r.productHandle ? root + '/products/' + r.productHandle : '';
      if (r.productImageUrl && href) { var pic = el('a', 'rvx__pic'); pic.href = href; pic.tabIndex = -1; pic.setAttribute('aria-hidden', 'true'); var img = el('img'); img.src = r.productImageUrl; img.alt = ''; img.width = 40; img.height = 50; img.loading = 'lazy'; pic.appendChild(img); who.appendChild(pic); }
      var w = el('div'), rv = r.reviewer || {};
      var tags = [rv.displayName || '']; var c = country(rv.location && rv.location.country && rv.location.country.code, lang); if (c) tags.push(c);
      w.appendChild(el('p', 'rvx__name', tags.filter(Boolean).join(' · ')));
      var meta = el('p', 'rvx__meta'), name = (r.productName || '').split(' – ')[0];
      if (name && href) { var l = el('a', null, name); l.href = href; meta.appendChild(l); } else if (name) meta.appendChild(document.createTextNode(name));
      var dt = date(r.dateCreated, lang); if (dt) meta.appendChild(document.createTextNode((name ? ' · ' : '') + dt));
      if (rv.isVerified) { meta.appendChild(document.createTextNode(' · ')); meta.appendChild(verifiedMark('rvx__ok', sec.getAttribute('data-verified'))); }
      w.appendChild(meta); who.appendChild(w); a.appendChild(who);
      return a;
    }
    function fade() {
      grid.querySelectorAll('.rvx-card__b').forEach(function (p) {
        var open = p.parentNode.classList.contains('is-open'), cut = !open && p.scrollHeight > p.clientHeight + 1, tg = p.nextElementSibling;
        p.classList.toggle('is-faded', cut);
        if (tg && tg.classList.contains('rvx-card__tg')) tg.hidden = !open && !cut;
      });
    }
    function load(url, replace) {
      if (busy && !replace) return; busy = true; var my = ++seq;
      json(url).then(function (d) {
        if (my !== seq) return;
        if (replace) grid.textContent = '';
        (d.reviews || []).forEach(function (r) { if (r && (r.body || r.title)) grid.appendChild(card(r)); });
        next = d.nextUrl ? 'https://api.okendo.io/v1' + d.nextUrl : null;
        more.hidden = !next; fade();
      }).catch(function () { if (replace && my === seq) { grid.textContent = ''; more.hidden = true; } }).then(function () { if (my === seq) busy = false; });
    }
    function pick(btn) {
      filters.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      load(base + '/collections/' + encodeURIComponent(btn.getAttribute('data-rvx-filter')) + '/reviews?limit=' + n + '&orderBy=date+desc&locale=' + lang, true);
    }
    filters.forEach(function (b) { b.addEventListener('click', function () { if (b.getAttribute('aria-pressed') !== 'true') pick(b); }); });
    more.addEventListener('click', function () { if (next) load(next, false); });
    if ('ResizeObserver' in window) new ResizeObserver(fade).observe(grid);
    if (filters[0]) pick(filters[0]);
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-rvx-score]').forEach(score);
    root.querySelectorAll('[data-rvx-hl]').forEach(highlights);
    root.querySelectorAll('[data-rvx-list]').forEach(function (sec) {
      if (!('IntersectionObserver' in window)) return list(sec);
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); list(sec); } }, { rootMargin: '800px 0px' });
      io.observe(sec);
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
